import { FEATURES } from '@/src/constants/Text'

// Peso padrão de uma pergunta (multiplicador de exibição: Resultado = resposta * peso).
// Espelha PESO_PADRAO (coluna NUMERIC NOT NULL DEFAULT 1) do backend.
export const DEFAULT_PESO = 1

// Mapa semântico: rótulo de desempenho → variante de cor do DS (consumida por
// BaseStatus em modo soft). Substitui o antigo colorPerformance (hex cru); as
// variantes são nomes de cor do DS ('success', 'danger', 'warning-new') ou
// token neutro, nunca hex literal.
export const PERFORMANCE_STATUS_VARIANT = {
  'metas não estabelecidas': 'neutral-400',
  'meta cumprida': 'success',
  'desempenho mediano': 'warning-new',
  'baixo desempenho': 'danger',
  pendente: 'warning-new',
  vencida: 'danger',
  concluída: 'success',
}

// Fallback neutro quando o rótulo não está mapeado.
const DEFAULT_PERFORMANCE_VARIANT = 'neutral-400'

// Rótulos de desempenho na ordem usada nos filtros (dropdown "Desempenho").
export const PERFORMANCE_STATUS_LABELS = Object.keys(PERFORMANCE_STATUS_VARIANT)

// Variante de cor do DS para um rótulo (case-insensitive) — passar direto na
// prop :color de <BaseStatus soft>.
export const performanceStatusColor = (label) => {
  const key = (label || '').toString().toLowerCase().trim()
  return PERFORMANCE_STATUS_VARIANT[key] || DEFAULT_PERFORMANCE_VARIANT
}

// Tokens de TEXTO legíveis (fundo branco) por variante — para colorir número/
// texto fora de um chip (ex.: média qualitativa), sempre via token, sem hex.
const PERFORMANCE_STATUS_TEXT_TOKEN = {
  'neutral-400': 'var(--neutral-700)',
  success: 'var(--success-text)',
  'warning-new': 'var(--warning-text)',
  danger: 'var(--danger-text)',
}

// CSS color (var(--...)) legível para um rótulo de desempenho.
export const performanceStatusTextColor = (label) =>
  PERFORMANCE_STATUS_TEXT_TOKEN[performanceStatusColor(label)] ||
  'var(--neutral-700)'

export const rhOptionsRoutes = (currentUser, showFeatures) => {
  const options = [
    {
      title: 'Visão Geral',
      subtitle: 'Resumo dos principais indicadores de desempenho do seu time',
      name: 'rh.geral',
      id: 'rh-overview-general',
      hasAccess: true,
    },
    {
      title: 'Análise Quantitativa',
      subtitle: 'Metas e resultados quantitativos por profissional',
      name: 'rh.quantitativa',
      id: 'rh-valuation-quantitative',
      hasAccess:
        showFeatures[FEATURES.BI_CUSTOMIZED] || showFeatures[FEATURES.BI_V2],
    },
    {
      title: 'Análise Comercial',
      subtitle: 'Esforço e performance comercial da equipe',
      name: 'rh.comercial',
      id: 'rh-valuation-commercial',
      hasAccess: true,
    },
    {
      title: 'Análise Qualitativa',
      subtitle: 'Avaliações qualitativas e médias por indicador',
      name: 'rh.qualitativa',
      id: 'rh-valuation-qualitative',
      hasAccess: true,
    },
    {
      title: 'Avaliações',
      subtitle: 'Aplique e acompanhe as avaliações de desempenho',
      name: 'rh.avaliacao',
      id: 'rh-view-valuation',
      hasAccess:
        currentUser.IS_GESTOR ||
        currentUser.leader ||
        showFeatures[FEATURES.RH_GESTOR],
    },
  ]
  return options.filter((opt) => opt.hasAccess)
}
